import React, { useState } from "react";
import { DISTRIBUTOR, USERGROUP, COMPANIES } from "../../constants/fetchData";
import { Eye, EyeOff } from "lucide-react";

const EntryFormContent = ({
  formData,
  handleChange,
  handleSubmit,
  handleCancel,
  type,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleDistributorChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    handleChange({
      target: {
        name: "distributor_name",
        value: selectedOptions,
      },
    });
  };

  return (
    <div className="flex flex-col h-full relative ">
      {/* Header area */}
      <div className="sticky top-0 bg-white z-10 pb-4 pt-6 w-full">
        <div className="flex justify-between items-center">
          <h1 className="text-text1 text-2xl sm:text-3xl  font-bold">
            {type} user
          </h1>
          <div className="hidden sm:block">
            <button
              onClick={handleSubmit}
              className="text-white bg-primary px-3.5 py-3 rounded-md"
            >
              Submit
            </button>
          </div>
        </div>
        <hr className="mt-5" />
      </div>
      <div className="flex-1 overflow-x-hidden pb-24 sm:pb-8">
        {/* Product Details Section */}
        <div className="text-text1 text-xl font-bold">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
            {/* User name */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Username
              </label>
              <input
                type="text"
                name="username"
                placeholder="Enter username"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.username}
                onChange={handleChange}
              />
            </div>
            {/* Password with eye toggle */}
            <div className="flex-1 relative items-center">
              <label className="font-medium text-sm leading-5 text-text2">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter password"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal pr-10"
                value={formData.password}
                onChange={handleChange}
              />
              <div
                className="absolute top-11 right-3 cursor-pointer text-gray-500"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
              </div>
            </div>
            {/* Phone number   */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Phone number
              </label>
              <input
                type="text"
                name="phone_number"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Enter phone number"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.phone_number}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, ""); // Remove non-numeric
                  // Limit max length if needed: onlyNums.slice(0, 15)
                  if (onlyNums.length <= 15) {
                    handleChange({
                      target: {
                        name: e.target.name,
                        value: onlyNums,
                      },
                    });
                  }
                }}
              />
            </div>
            {/* Email address Input */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Email address
              </label>
              <input
                type="text"
                name="email"
                placeholder="Enter email address "
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            {/* User group Dropdown */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text">
                User group
              </label>
              <div className="primary-dropdown mt-1">
                <select
                  name="GroupName"
                  className={`rounded px-1 text-sm font-normal  focus:outline-none focus:ring-0 w-full ${
                    formData.GroupName === "" ? "text-gray-400" : "text-text1"
                  } `}
                  value={formData.GroupName}
                  onChange={handleChange}
                >
                  <option disabled value="">
                    Select
                  </option>

                  {/* {USERGROUP.map((user) => (
                  <option key={user.id}>{user.name}</option>
                ))} */}
                  <option value="Avana_Employee" className="text-text1">
                    Internal User
                  </option>
                  <option value="Distributor" className="text-text1">
                    Distributor
                  </option>
                  <option value="Distributor_Admin" className="text-text1">
                    Distributor Admin
                  </option>
                  {/* <option value="Manager">Internal Manager</option> */}
                </select>
              </div>
            </div>
            {/* Distributor name Input - Multi or Single based on user group */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text">
                Distributor name
              </label>
              <div className="mt-1">
                {formData.GroupName === "Avana_Employee" ? (
                  <div className="flex flex-col gap-2 border p-2 rounded max-h-48 overflow-y-auto">
                    {COMPANIES.map((code) => (
                      <label
                        key={code.value}
                        className="flex items-center gap-2 text-sm font-normal text-text1"
                      >
                        <input
                          type="checkbox"
                          value={code.value}
                          checked={formData.distributor_name?.includes(
                            code.value
                          )}
                          className="accent-green"
                          onChange={(e) => {
                            const value = e.target.value;
                            const isChecked = e.target.checked;
                            const selected = new Set(
                              formData.distributor_name || []
                            );
                            if (isChecked) {
                              selected.add(value);
                            } else {
                              selected.delete(value);
                            }
                            handleChange({
                              target: {
                                name: "distributor_name",
                                value: Array.from(selected),
                              },
                            });
                          }}
                        />

                        {code.label}
                      </label>
                    ))}
                  </div>
                ) : (
                  <div className="primary-dropdown">
                    <select
                      name="distributor_name"
                      className={`rounded px-1 text-sm font-normal w-full focus:outline-none focus:ring-0 ${
                        formData.distributor_name === ""
                          ? "text-gray-400"
                          : "text-text1"
                      }`}
                      value={formData.distributor_name || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {COMPANIES.map((code) => (
                        <option
                          key={code.value}
                          value={code.value}
                          className="text-text1"
                        >
                          {code.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed button container at the bottom for mobile */}
      <div className="block sm:hidden ">
        <div className=" absolute bottom-0 left-0 right-0 z-10 bg-white opacity-85 border-gray-200  flex justify-end py-2 gap-2">
          <button
            onClick={handleCancel}
            className="text-text1 bg-white border border-gray-300 px-3 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="text-white bg-primary px-3 py-2 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EntryFormContent;
